const initialState = {
    items: [
    ]
}

export default function reducer(state = initialState, action) {

    return state;
}